import Header from "./component/Header";
import Home from "./Pages/Home";
import CheckOut from "./Pages/CheckOut";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Login from "./Pages/Login";
import { useEffect } from "react";
import { auth } from "./firebase";
import { useStateValue } from "./StateProvider";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import Payment from "./Pages/Payment";
import ItemDetails from "./Pages/ItemDetails";

const stripePromise = loadStripe(
  "pk_test_51Is4RWChYfYv8sInew6BcFKmbWaDyUlGFGyIZt6uy8ck2R6YysbxylhZzHk73MQOihsuraUU4IpI3UV8jQP3IkdC007HODdsgg"
);

function App() {
  const [{}, dispatch] = useStateValue();

  useEffect(() => {
    // this will always listen to the state of the occount either signed in or out
    // and will send the data to the context

    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        // the user is logged in
        dispatch({
          type: "SET_USER",
          user: authUser,
        });
      } else {
        // the user is logged out
        dispatch({
          type: "SET_USER",
          user: null,
        });
      }
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <Route exact path="/">
          <Header />
          <Home />
        </Route>
        <Route exact path="/details/:id">
          <Header />
          <ItemDetails />
        </Route>
        <Route exact path="/checkout">
          <Header />
          <CheckOut />
        </Route>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/payment">
          <Header />
          <Elements stripe={stripePromise}>
            <Payment />
          </Elements>
        </Route>
      </div>
    </Router>
  );
}

export default App;
